__webpack_require__.p = "/vocabs/";